'use strict';

export class FormControlProvider {
  constructor(fdFormControlTypes) {
    'ngInject';

    // Holds the constants
    this.controlTypes = fdFormControlTypes;

    // Contains type specific attributes
    this.types = {};
  }

  /**
   * A modifier is defined by its type (modifier criteria)
   * and its modifier value (either a string suffix or a function).
   */
  setTypeModifier(type, modifier) {
    if (!this.types[type]) {
      this.types[type] = {};
    }
    this.types[type].typeModifier = modifier;
  }

  /**
   * Set options to specific types which will be applied
   * to the target control type at runtime.
   */
  setTypeOptions(type, options) {
    if (!this.types[type]) {
      this.types[type] = {};
    }
    this.types[type].typeOptions = options;
  }

  $get() {
    'ngInject';
    const { controlTypes, types, setTypeModifier, setTypeOptions } = this;

    return {
      controlTypes,
      types,
      setTypeModifier,
      setTypeOptions
    }
  }
}
